"use client";

import { useTranslation } from "@/lib/react/i18n";
import React, { MouseEvent } from "react";


interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (e: MouseEvent<HTMLButtonElement>) => void;
  alertMessages: string[];
}

const YesAndNoModal: React.FC<ModalProps> = ({ isOpen, onClose, onConfirm, alertMessages }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-blue-100 p-6 rounded-md shadow-lg w-80">
        <div className="text-center mb-4">
          {
            alertMessages.map((msg, index) => (
              <p key={index} className="text-gray-800 mt-2 text-sm">{msg}</p>

            ))
          }
        </div>
        <div className="flex justify-between mt-4">
          <button
            onClick={onClose}
            className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 transition"
          >
            {t('No')}
          </button>
          <button
            onClick={onConfirm}
            className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 transition"
          >
            {t('Yes')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default YesAndNoModal;